import { fg } from '@atlassian/jira-feature-gating';

const isIssueViewFieldConfigEditEnabled = {
	get(): boolean {
		return fg('issue_view_field_config_edit');
	},
};

export default isIssueViewFieldConfigEditEnabled;
